import React, { useMemo } from 'react'
import { TableV2MobileHeader, TableV2MobileHeaderTd, TableV2MobileHeaderTitle, TableV2Td } from '../index.styled'
import { Skeleton } from './index.styled'
import TableV2Row from '../row'
import { pairHeaders } from '../helper'

const TableV2RowSkeleton = React.memo(({ headers, columns }) => {
	const headerPairs = useMemo(() => pairHeaders(headers), [headers])
	return (
		<TableV2Row headers={headers} columns={columns} testId="table-v2-skeleton">
			{headerPairs.map(([leftHeader, rightHeader], i) => (
				<React.Fragment key={i}>
					<TableV2MobileHeader>
						<TableV2MobileHeaderTd><TableV2MobileHeaderTitle>{leftHeader.title}</TableV2MobileHeaderTitle></TableV2MobileHeaderTd>
						{rightHeader &&
							<TableV2MobileHeaderTd><TableV2MobileHeaderTitle>{rightHeader.title}</TableV2MobileHeaderTitle></TableV2MobileHeaderTd>}
					</TableV2MobileHeader>
					<TableV2Td className={leftHeader.className}><Skeleton /></TableV2Td>
					{rightHeader && <TableV2Td className={rightHeader.className}><Skeleton /></TableV2Td>}
				</React.Fragment>
			))}
		</TableV2Row>
	)
})

TableV2RowSkeleton.displayName = 'TableV2RowSkeleton'
export default TableV2RowSkeleton
